// eslint-disable-next-line no-shadow
export var IPublicEnumPropValueChangedType = /*#__PURE__*/function (IPublicEnumPropValueChangedType) {
  IPublicEnumPropValueChangedType["SET_VALUE"] = "SET_VALUE";
  IPublicEnumPropValueChangedType["SUB_VALUE_CHANGE"] = "SUB_VALUE_CHANGE";
  return IPublicEnumPropValueChangedType;
}({});

/**
 * @deprecated please use IPublicEnumPropValueChangedType
 */
export var PROP_VALUE_CHANGED_TYPE = /*#__PURE__*/function (PROP_VALUE_CHANGED_TYPE) {
  PROP_VALUE_CHANGED_TYPE["SET_VALUE"] = "SET_VALUE";
  PROP_VALUE_CHANGED_TYPE["SUB_VALUE_CHANGE"] = "SUB_VALUE_CHANGE";
  return PROP_VALUE_CHANGED_TYPE;
}({});